import * as React from "react";
import {
  StyleSheet,
  View,
  ImageBackground,
  ScrollView,
  Image,
} from "react-native";
import {
  Text,
  Provider as PaperProvider,
  DefaultTheme,
} from "react-native-paper";
import { connect } from "react-redux";
import { actionCreators } from "../../test/action";
import routes from "../../routing/routes";
import { blackColor, whiteColor, greyColorText } from "../../common/colors";
import Button from "../../common/Button";
import ModalHeaderSettings from "../../common/ModalHeaderSettings";
import logoInfo from "../Images/logoInfo.png";
import appJSON from "../../../app.json";
import Background from "../../common/Background";
import PageContainer from "../../common/PageContainer";
import t from "../../translations";

const AboutLoriiniApp = (props) => {
  const theme = {
    ...DefaultTheme,
    roundness: 0,
    colors: {
      ...DefaultTheme.colors,
      primary: blackColor,
    },
  };

  return (
    <PageContainer
      {...props}
      isBackIcon={true}
      isSettingsIconSelected={true}
      backRoute={routes.Settings}
      noBackground={true}
    >
      <View style={styles.infoContainer}>
        <Text style={styles.info}>{t('about_LoriiniApp_title')}</Text>
      </View>
      <View style={styles.logoInfoDesign}>
        <Image source={logoInfo} style={styles.logo}></Image>
      </View>

      <View style={styles.loriiniTribes}>
        <Text style={styles.copyright}>Copyright © Loriini Tribes </Text>
        <Text style={styles.versionInfo}>
          (v.{appJSON.expo.version}) - 2021
        </Text>
        <Text style={styles.companySlogan}>{t('about_LoriiniApp_slogan_one')}</Text>
        <Text style={styles.companySlogan}>{t('about_LoriiniApp_slogan_two')}</Text>
      </View>
      <View style={styles.contactButton}>
        <Button
          mode="outlined"
          value={t('about_LoriiniApp_button')}
          onPress={() => props.navigation.navigate(routes.Contact)}
        ></Button>
      </View>
    </PageContainer>
  );
};

const mapStateToProps = (state) => {
  const user = state.user;
  return { user };
};

export default connect(mapStateToProps, actionCreators)(AboutLoriiniApp);

const styles = StyleSheet.create({
  wrapper: {
    alignItems: "center",
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    paddingTop: 0,
    width: "100%",
    backgroundColor: whiteColor,
  },
  container: {
    width: "100%",
    height: "100%",
  },
  infoContainer: {
    paddingTop: 23,
    paddingLeft: 20,
    alignItems: "flex-start",
    alignContent: "center",
    justifyContent: "center",
  },
  info: {
    fontSize: 16,
    lineHeight: 26,
    letterSpacing: 1.25,
    fontWeight: "400",
    color: blackColor,
    textTransform: "uppercase",
  },
  scrollView: {
    backgroundColor: whiteColor,
    paddingBottom: 0,
    height: "100%",
    paddingTop: 0,
    width: "100%",
  },

  loriiniTribes: {
    justifyContent: "center",
    alignItems: "center",
  },
  companySlogan: {
    fontSize: 14,
    lineHeight: 21,
    letterSpacing: 1.25,
    fontWeight: "400",
  },
  logoInfoDesign: {
    flexDirection: "column",
    flexWrap: "nowrap",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
  },
  logo: {
    marginTop: 50,
    width: 199,
    height: 208,
  },
  copyright: {
    fontSize: 12,
    lineHeight: 21,
    letterSpacing: 1.25,
    fontWeight: "400",
    color: greyColorText,
  },
  versionInfo: {
    fontSize: 12,
    lineHeight: 21,
    paddingBottom: 20,
    letterSpacing: 1.25,
    fontWeight: "400",
    color: greyColorText,
    textAlign: "center",
  },
  infoAboutApp: {
    marginBottom: 0,
    marginTop: 50,
  },
  contactButton: {
    alignItems: "center",
    position: "relative",
    top: 0,
    marginBottom: 40,
    left: 0,
    right: 0,
    marginTop: 40,
    width: "100%",
  },
});
